import script from "./AdminShop.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminShop.vue?vue&type=script&setup=true&lang=ts"

import "./AdminShop.vue?vue&type=style&index=0&id=6bb98382&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb98382"]])

export default __exports__